import React from 'react';

import Button from "components/CustomButtons/Button.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@material-ui/core";

import Api from '../../../../api/Api.js';
import CustomerEndpoints from '../../../../api/CustomerEndpoints';
import ReactSelect from '../../../../components/Select/ReactSelect';
import UserImage from '../../../../components/Image/UserImage';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class SetSalesPersonDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentSalesPerson: { label: props.sales_person ? props.sales_person.name + (props.sales_person.surname ? " " + props.sales_person.surname : "") : 'None', value: props.sales_person ? props.sales_person.id : '' },
            loading: false
        }
    }

    submit() {
        this.setState({ loading: true }, () =>
            Api.post(CustomerEndpoints.setSalesPerson, { customer_id: this.props.customer_id, sales_id: this.state.currentSalesPerson.value })
                .then(({ data }) => {
                    this.props.close();
                    this.props.refresh(data);
                    this.setState({ loading: false })
                })
                .catch((e) => this.setState({ loading: false }, () => console.error(e)))
        );
    }

    render() {
        const { classes } = this.props;
        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
                PaperProps={{ style: { overflow: 'visible' } }}
            >
                <DialogTitle id="form-dialog-title">Sales Person</DialogTitle>
                <DialogContent style={{ overflow: 'visible' }}>
                    <ReactSelect
                        options={
                            this.props.users && this.props.users.length > 0 ?
                                this.props.users.map(u => ({ label: u.name + (u.surname ? " " + u.surname : ''), avatar: <UserImage {...u} />, value: u.id }))
                                :
                                [{ label: 'None', value: '' }]
                        }
                        onChange={(value) => this.setState({ currentSalesPerson: value })}
                        placeholder="No Sales Person Selected"
                        value={this.state.currentSalesPerson}
                        isSearchable
                        isLoading={!this.props.users || this.props.users.length === 0}
                        isDisabled={!this.props.users || this.props.users.length === 0}
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>


                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                            >
                                Set Sales Person
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(SetSalesPersonDialog);